import type {DiffSide, StaticDiffLine} from '@github-ui/diff-lines/conversation-types'
import {PageData} from '@github-ui/pull-request-page-data-tooling/page-data'
import {usePageDataUrl} from '@github-ui/pull-request-page-data-tooling/use-page-data-url'
import {reactFetch} from '@github-ui/verified-fetch'
import {useQuery} from '@github-ui/react-query'

export type ThreadPreviewPositioning = {
  [threadId: number]: {
    diffLines: StaticDiffLine[]
    endDiffSide?: DiffSide
    endLine?: number | null
    isOutdated?: boolean
    path: string
    startDiffSide?: DiffSide
    startLine?: number | null
  }
}

export function useThreadPreviewPositioning(threadIds: number[]) {
  const threadPreviewPositioningUrl = `${usePageDataUrl(PageData.threadPreviewPositioning)}?thread_ids=${threadIds.join(
    ',',
  )}`

  return useQuery<ThreadPreviewPositioning>({
    queryKey: [PageData.threadPreviewPositioning, threadPreviewPositioningUrl],
    queryFn: async () => {
      if (!threadIds.length) {
        return {}
      }

      const result = await reactFetch(threadPreviewPositioningUrl)
      if (!result.ok) throw new Error(`HTTP ${result.status}`)
      const json = await result.json()
      return json
    },
    staleTime: Infinity,
  })
}
